
import { Component, Vue } from 'vue-property-decorator'
import EnterpriseEmployeeService from '@/biz/service/Enterprise/EnterpriseEmployeeService'

@Component
export default class ViewEnterpriseEmployeeIndex extends Vue {
  private Service = EnterpriseEmployeeService
}
